import { render, staticRenderFns } from "./messageImport.vue?vue&type=template&id=2cb969f2&scoped=true&"
import script from "./messageImport.vue?vue&type=script&lang=js&"
export * from "./messageImport.vue?vue&type=script&lang=js&"
import style0 from "./messageImport.vue?vue&type=style&index=0&id=2cb969f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb969f2",
  null
  
)

export default component.exports